import React, { useState } from 'react';

const HouseKeeping = () => {
  const [isRoomCleaningPopupVisible, setRoomCleaningPopupVisible] = useState(false);
  const [isLaundryPopupVisible, setLaundryPopupVisible] = useState(false);
  const [isRoomFreshningPopupVisible, setRoomFreshningPopupVisible] = useState(false);

  const handleDeepRoomCleaningClick = () => {
    setRoomCleaningPopupVisible(true);
  };

  const closeRoomCleaningPopup = () => {
    setRoomCleaningPopupVisible(false);
  };

  const handleLaundryClick = () => {
    setLaundryPopupVisible(true);
  };

  const closeLaundryPopup = () => {
    setLaundryPopupVisible(false);
  };

  const handleRoomFreshningClick = () => {
    setRoomFreshningPopupVisible(true);
  };

  const closeRoomFreshningPopup = () => {
    setRoomFreshningPopupVisible(false);
  };

  return (
    <div className="bg-gray-100 h-screen">
      {/* Header Section */}
      <header className="text-white p-6 text-center">
        <h1 className="text-xl font-bold text-center text-black mt-5">Housekeeping Services</h1>
        <h2 className="text-xs font-poppins font-semibold text-center mb-1 text-black">
          From laundry to room cleaning, our housekeeping services are designed to make your stay
          more comfortable.
        </h2>
        <hr className="border border-gray-400 w-2/4 mx-auto mb-" />
      </header>

      {/* Main Content Section */}
      <div className="flex justify-center items-center p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {/* Deep Room Cleaning Service Card */}
          <div className="bg-white shadow-lg rounded-lg overflow-hidden transition-all hover:shadow-xl h-full">
            <div className="p-6 flex flex-col">
              <h3 className="text-xl font-semibold text-gray-800">Deep Room Cleaning</h3>
              <p className="text-gray-600 mt-2 text-sm">
                A thorough cleaning of your room to ensure your space is pristine and fresh.
              </p>
              <p className="text-gray-700 mt-4 font-medium">Price: ₹300</p>
              <div className="mt-4 text-center">
                <button
                  onClick={handleDeepRoomCleaningClick}
                  className="bg-cyan-500 text-white px-4 py-2 rounded-md hover:text-black transition-all text-sm shadow-md"
                >
                  Book Service
                </button>
              </div>
            </div>
          </div>

          {/* Laundry Service Card */}
          <div className="bg-white shadow-lg rounded-lg overflow-hidden transition-all hover:shadow-xl h-full">
            <div className="p-6 flex flex-col">
              <h3 className="text-xl font-semibold text-gray-800">Laundry Services</h3>
              <p className="text-gray-600 mt-2 text-sm">
                Freshen up your clothes with our laundry services, including washing and ironing.
              </p>
              <p className="text-gray-700 mt-4 font-medium">Price: ₹20</p>
              <div className="mt-4 text-center">
                <button
                  onClick={handleLaundryClick}
                  className="bg-cyan-500 text-white px-4 py-2 rounded-md hover:text-black transition-all text-sm shadow-md"
                >
                  Book Service
                </button>
              </div>
            </div>
          </div>

          {/* Room Freshening Service Card */}
          <div className="bg-white shadow-lg rounded-lg overflow-hidden transition-all hover:shadow-xl h-full">
            <div className="p-6 flex flex-col">
              <h3 className="text-xl font-semibold text-gray-800">Room Freshening</h3>
              <p className="text-gray-600 mt-2 text-sm">
                Keep your room smelling fresh with our room freshening services.
              </p>
              <p className="text-gray-700 mt-4 font-medium">Price: ₹300</p>
              <div className="mt-4 text-center">
                <button
                  className="bg-cyan-500 text-white px-4 py-2 rounded-md hover:text-black transition-all text-sm shadow-md"
                  onClick={handleRoomFreshningClick}
                >
                  Book Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Room Cleaning Popup */}
      {isRoomCleaningPopupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
            {/* Close Button */}
            <button
              onClick={closeRoomCleaningPopup}
              className="absolute top-4 right-4 text-gray-600 hover:text-red-500 focus:outline-none"
              aria-label="Close"
            >
              ✖
            </button>

            {/* Header */}
            <h2 className="text-xl font-semibold text-gray-800 text-center mb-6">
              Deep Room Cleaning
            </h2>

            {/* Form */}
            <form className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                {/* Service */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Service</label>
                  <input
                    type="text"
                    value="Room Cleaning"
                    readOnly
                    className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 focus:outline-none"
                  />
                </div>

                {/* Price */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Price (₹)</label>
                  <input
                    type="text"
                    value="₹300"
                    readOnly
                    className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 focus:outline-none"
                  />
                </div>

                {/* Time Preference */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Time Preference</label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-400 focus:outline-none">
                    <option>Immediate</option>
                    <option>Scheduled</option>
                  </select>
                </div>

                {/* Linen Change */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Linen Change</label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-400 focus:outline-none">
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>

                {/* Additional Services */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Additional Services
                  </label>
                  <input
                    type="text"
                    placeholder="Any"
                    className="w-full  mt-2 px-4 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 "
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Special Requests
                  </label>

                  <input
                    placeholder="Write Your Message"
                    type="text"
                    className=" mt-2 px-6 py-2 border border-gray-300 rounded-lg bg-white "
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-6 text-center">
                <button
                  type="button"
                  className="bg-cyan-500 mt-6 hover:text-black text-white font-semibold py-2 px-9 rounded-lg "
                >
                  Book Appointment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Laundry Popup */}
      {isLaundryPopupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
            <button
              onClick={closeLaundryPopup}
              className="absolute top-4 right-4 text-gray-600 hover:text-red-500 focus:outline-none"
              aria-label="Close"
            >
              ✖
            </button>
            <h2 className="text-xl font-semibold text-gray-800 text-center mb-6">
              Laundry Services
            </h2>
            <form className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                {/* Service Options */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Service Options</label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Laundry</option>
                    <option>Dry Cleaning</option>
                  </select>
                </div>

                {/* No of Items */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">No Of Items</label>
                  <input
                    type="number"
                    placeholder="Enter number of items"
                    className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
                  />
                </div>

                {/* Time Preference */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Time Preference</label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Immediate</option>
                    <option>Next Day</option>
                    <option>Flexible</option>
                  </select>
                </div>

                {/* Iron the Clothes */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Iron the Clothes
                  </label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>

                {/* Price */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Price (₹)</label>
                  <input
                    type="text"
                    value="₹0"
                    readOnly
                    className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 focus:outline-none"
                  />
                </div>

                {/* Additional Services */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Additional Services
                  </label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Any</option>
                    <option>Stain Removal</option>
                    <option>Delicate Wash</option>
                  </select>
                </div>
              </div>

              {/* Special Requests */}
              <div>
                <label className="block text-sm font-medium text-gray-700">Special Requests</label>
                <textarea
                  placeholder="Write Your Message"
                  className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
                ></textarea>
              </div>

              {/* Book Appointment Button */}
              <div className="text-center">
                <button
                  type="button"
                  className="bg-cyan-500 text-white px-6 py-2 rounded-lg hover:text-black"
                >
                  Book Appointment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isRoomFreshningPopupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
            <button
              onClick={closeRoomFreshningPopup}
              className="absolute top-4 right-4 text-gray-600 hover:text-red-500 focus:outline-none"
              aria-label="Close"
            >
              ✖
            </button>
            <h2 className="text-xl font-semibold text-gray-800 text-center mb-6">Quick Refresh</h2>
            <form className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                {/* Service */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Service</label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Quick-Refresh</option>
                  </select>
                </div>

                {/* Price */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Price</label>
                  <input
                    type="number"
                    value="0"
                    readOnly
                    className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 focus:outline-none"
                  />
                </div>

                {/* Time Preference */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Time Preference</label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Immediate</option>
                    <option>Next Day</option>
                    <option>Flexible</option>
                  </select>
                </div>

                {/* Areas to Focus On */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Areas to Focus On
                  </label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Bathroom</option>
                    <option>Bed and Pillows</option>
                    <option>Desk and Work Area</option>
                  </select>
                </div>

                {/* Additional Services */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Additional Services
                  </label>
                  <select className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none">
                    <option>Any</option>
                    <option>Stain Removal</option>
                    <option>Delicate Wash</option>
                  </select>
                </div>
                {/* Special Requests */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Special Requests
                  </label>
                  <input
                    placeholder="Write Your Message"
                    className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
                  />
                </div>
              </div>

              {/* Book Appointment Button */}
              <div className="text-center">
                <button
                  type="button"
                  className="bg-cyan-500 mt-6 text-white hover:text-black px-6 py-2 rounded-lg "
                >
                  Book Appointment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default HouseKeeping;
